export enum NavLinkPaths {
  ORDER = '/collections/all',
  ORDER_HISTORY = '/pages/order-history',
  HELP_AND_SUPPORT = '/pages/help-support',
  ACCOUNT_DETAILS = '/account/addresses',
  LOG_OUT = '/account/logout'
}
